import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { State } from "redux/store";
import { getExportRequestData } from "redux/SingleDataset/selectors";
import useAllQueryParamsFilters from "hooks/useAllQueryParamsFilters";
import { submitSelectedCartTags } from "redux/SingleDataset/actions";

export const useTagAssigment = (tempExport: boolean = false) => {
  const dispatch = useDispatch();
  const { datasetId, clusterId } = useParams();
  const queryParamsFilters = useAllQueryParamsFilters();
  const exportRequestData = useSelector((state: State) =>
    getExportRequestData(state, queryParamsFilters, tempExport),
  );

  const handleTagSubmit = async (tagIDs: string[]) => {
    try {
      const formattedRequest: Record<string, any[]> = {};
      tagIDs.forEach((id) => {
        formattedRequest[id] = exportRequestData;
      });
      await dispatch(
        submitSelectedCartTags(
          String(datasetId),
          formattedRequest,
          queryParamsFilters,
          clusterId,
        ) as any,
      );
      return { success: true };
    } catch (error) {
      console.log(error);
      return { success: false };
    }
  };

  return {
    handleTagSubmit,
  };
};
